var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8375 70.8333L23.0875 52.8375L28.9 46.8583L41.7333 59.0958L70.9875 29.1667L76.9125 35.0375L41.8375 70.8333ZM20.8333 8.33333C13.9417 8.33333 8.33333 13.9417 8.33333 20.8333V79.1667C8.33333 86.0583 13.9417 91.6667 20.8333 91.6667H79.1667C86.0583 91.6667 91.6667 86.0583 91.6667 79.1667V20.8333C91.6667 13.9417 86.0583 8.33333 79.1667 8.33333H20.8333ZM100 20.8333V79.1667C100 90.6708 90.675 100 79.1667 100H20.8333C9.325 100 0 90.6708 0 79.1667V20.8333C0 9.32917 9.325 0 20.8333 0H79.1667C90.675 0 100 9.32917 100 20.8333Z",
    fill: "#EBF2FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/Activity_Icon.5d8b5dbee5dd7d9b060ef03026862904.svg";
export { ForwardRef as ReactComponent };